import useLabels from '../../hooks/useLabels';
import { Link, LinkProps, NavigateOptions, To, useNavigate } from 'react-router-dom';
import { FC, useCallback } from 'react';
import { useRouteStateContext } from './RouteStateContext';

export const useSafeNavigate = () => {
    const labels = useLabels();
    const navigate = useNavigate();
    const { isDirty } = useRouteStateContext();

    const safeNavigate = useCallback((to: To, options?: NavigateOptions) => {
        if (isDirty) {
            const confirm = window.confirm(labels.youHaveUnsavedChangesPrompt);
            if (!confirm) return;
        }
        navigate(to, options);
    }, [isDirty, labels.youHaveUnsavedChangesPrompt, navigate]);

    return safeNavigate;
};


const DirtyAwareLink: FC<LinkProps> = ({ to, children }) => {
    const { isDirty } = useRouteStateContext();
    const safeNavigate = useSafeNavigate();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (isDirty) {
            e.preventDefault();
            safeNavigate(to);
        }
    };

    return (
        <Link to={to} onClick={handleClick}>{children}</Link>
    );
};

export default DirtyAwareLink;